import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronDownIcon, MagnifyingGlassIcon, Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isStickyHeaderVisible, setIsStickyHeaderVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolled(scrollTop > 100);
      setIsStickyHeaderVisible(scrollTop > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Discover", href: "/campaigns" },
    { label: "About", href: "/about" },
    // { label: "Pricing & Fees", href: "/pricing-and-fees" },
    { label: "Sign In", href: "/site/login" },
  ];

  return (
    <>
      {/* DESKTOP NAV */}
      <nav
        className={`absolute inset-x-0 top-0 z-50 hidden xl:block transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-md shadow-lg" : "bg-transparent"
        }`}
      >
        <div className="flex flex-col p-4 mx-auto">
          <div className="container flex items-center mx-auto">
            {/* LEFT */}
            <div className="flex justify-start font-bold space-x-14 basis-1/3">
             <Link to="/" id="logo__link">
  <span className="text-white font-bold text-6xl">
    DonatePe
  </span>
</Link>


              <div className="menu-item flex items-center space-x-1 cursor-pointer group">
                <Link to="/campaigns" className="text-white hover:text-teal-300 transition-colors">
                  Discover
                </Link>
                <ChevronDownIcon className="w-4 h-4 text-white group-hover:text-teal-300" />
              </div>

              <button className="flex items-center">
                <MagnifyingGlassIcon className="w-6 h-6 text-white hover:text-teal-300 transition-colors" />
              </button>
            </div>

            {/* RIGHT */}
            <div className="flex items-center justify-end space-x-12 basis-2/3">
              {navItems.slice(1).map((item) =>
                item.href.includes("/site/") ? (
                  <a
                    key={item.label}
                    href={item.href}
                    className="text-white hover:text-teal-300 transition-colors"
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.label}
                    to={item.href}
                    className="text-white hover:text-teal-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                )
              )}

              <a
                href="/site/signup_email"
                id="start-camp-header"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full transition-colors"
              >
                Start a GiveSendGo
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* MOBILE NAV */}
      <nav className="absolute inset-x-0 top-0 z-50 block xl:hidden bg-transparent">
        <div className="flex justify-between p-4 mx-auto">
          {/* <Link to="/">
            <img
              src="https://static2.givesendgo.com/vue/gsg-logo-all-white.png"
              className="w-44 lg:w-52"
              alt="GiveSendGo Logo"
            />
          </Link> */}
               <Link to="/" id="logo__link">
  <span className="text-white font-bold text-6xl">
    DonatePe
  </span>
</Link>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            className="flex items-center justify-center"
          >
            {isMenuOpen ? <XMarkIcon className="w-8 h-8 text-white" /> : <Bars3Icon className="w-8 h-8 text-white" />}
          </button>
        </div>
      </nav>

      {/* STICKY HEADER */}
      {isStickyHeaderVisible && (
        <header className="sticky top-0 z-40 bg-white shadow-lg transition-all duration-300">
          <nav className="hidden xl:block">
            <div className="flex flex-col p-4 mx-auto">
              <div className="container flex items-center mx-auto">
                {/* LEFT */}
                <div className="flex justify-start font-bold basis-1/3 space-x-14">
                  {/* <Link to="/" id="logo__link">
                    <img
                      src="https://static2.givesendgo.com/images/Cyan%20Horiz%20Sub.png"
                      alt="GiveSendGo Logo"
                      className="w-52"
                    />
                  </Link> */}
                   <Link to="/" id="logo__link">
  <span className="text-black font-bold text-6xl">
    DonatePe
  </span>
</Link>

                  <div className="menu-item flex items-center space-x-1 cursor-pointer group">
                    <Link to="/campaigns" className="text-gray-800 hover:text-teal-600">
                      Discover
                    </Link>
                    <ChevronDownIcon className="w-4 h-4 text-gray-800 group-hover:text-teal-600" />
                  </div>

                  <button className="flex items-center">
                    <MagnifyingGlassIcon className="w-6 h-6 text-gray-800 hover:text-teal-600" />
                  </button>
                </div>

                {/* RIGHT */}
                <div className="flex items-center justify-end space-x-12 basis-2/3">
                  {navItems.slice(1).map((item) =>
                    item.href.includes("/site/") ? (
                      <a
                        key={item.label}
                        href={item.href}
                        className="text-gray-800 hover:text-teal-600"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        key={item.label}
                        to={item.href}
                        className="text-gray-800 hover:text-teal-600"
                      >
                        {item.label}
                      </Link>
                    )
                  )}

                  <a
                    href="/site/signup_email"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full"
                  >
                    Start a GiveSendGo
                  </a>
                </div>
              </div>
            </div>
          </nav>
        </header>
      )}

      {/* MOBILE MENU OVERLAY */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md xl:hidden">
          <div className="absolute top-4 right-4">
            <button onClick={() => setIsMenuOpen(false)} aria-label="Close menu">
              <XMarkIcon className="w-8 h-8 text-white" />
            </button>
          </div>

          <div className="flex flex-col items-center justify-center h-full space-y-8">
            {navItems.map((item) =>
              item.href.includes("/site/") ? (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-white text-2xl hover:text-teal-300"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  className="text-white text-2xl hover:text-teal-300"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )
            )}

            <a
              href="/site/signup_email"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 text-lg rounded-full"
              onClick={() => setIsMenuOpen(false)}
            >
              Start a GiveSendGo
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
